import React from 'react';
import './Home.css';

import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';

import {
  FaClipboardCheck,
  FaStore,
  FaFileMedical,
    FaFileSignature,
      FaCheckCircle,

  FaBuilding,
  FaChair
} from "react-icons/fa";


const services = [

{
text:"תכנון העסק",
icon:<FaClipboardCheck/>
},

{
text:"התאמת העסק והדרכה בהתאם לצו רישוי עסקים",
icon:<FaStore/>
},

{
text:"אישור הרשויות המקומיות",
icon:<FaBuilding/>
},

{
text:"אישור משרד הבריאות",
icon:<FaFileMedical/>
},

{
text:"היתר כסאות שולחנות חיצוני וסגירות חורף",
icon:<FaChair/>
}

];





export const Home = () => (

<Container>


<div style={styles.mainContainer}>


<Fade bottom>

{/* HERO */}

<div style={styles.heroSection}>


<h1 style={styles.heroTitle}>

<span>
מקימים עסק
</span>

<div style={styles.heroIcon}>
<FaStore/>
</div>

</h1>




<h1 style={styles.heroTitle}>

<span>
מחדשים רישיון
</span>


<div style={styles.heroIcon}>
<FaFileSignature/>
</div>


</h1>





<h1 style={styles.heroTitle}>

<span>
הגעתם למקום הנכון
</span>


<div style={styles.heroIcon}>
<FaCheckCircle/>
</div>


</h1>



</div>




{/* SERVICES */}


<div style={styles.servicesGrid}>


{

services.map((item,index)=>(


<div 
key={index}
style={styles.serviceCard}
>


<div style={styles.iconCircle}>

{item.icon}

</div>



<h3 style={styles.serviceText}>

{item.text}

</h3>



</div>


))


}



</div>




</Fade>


</div>


</Container>

);





const styles = {

heroIcon:{


width:'55px',

height:'55px',


borderRadius:'50%',


background:
'linear-gradient(135deg,#00c6ff,#0072ff)',


display:'flex',

alignItems:'center',

justifyContent:'center',


color:'#fff',


fontSize:'28px',


boxShadow:
'0 0 25px rgba(0,140,255,.8)',


flexShrink:0


},
mainContainer:{


direction:'rtl',

textAlign:'center',

padding:'clamp(30px,6vw,70px) 15px',

fontFamily:'Segoe UI, Tahoma, Geneva, sans-serif',

minHeight:'100vh',

width:'100%',

boxSizing:'border-box'


},




heroSection:{


marginBottom:'40px',

display:'flex',

flexDirection:'column',

alignItems:'center',

gap:'18px'


},




heroTitle:{


display:'flex',

alignItems:'center',

justifyContent:'center',

flexWrap:'wrap',

gap:'10px',


fontSize:'clamp(1.5rem,5vw,2.6rem)',


fontWeight:'800',

color:'#ffffff',

margin:0,


textShadow:
'0 6px 20px rgba(0,0,0,.3)',


lineHeight:'1.3'


},





mainIcon:{


height:'clamp(30px,8vw,52px)',

width:'auto',

objectFit:'contain'


},





servicesGrid:{


width:'100%',

maxWidth:'820px',

margin:'0 auto',


display:'flex',

flexDirection:'column',


gap:'12px',


padding:'0 5px',

boxSizing:'border-box'


},






serviceCard:{


display:'flex',

alignItems:'center',


padding:'15px',


borderRadius:'16px',


background:'rgba(255,255,255,.08)',


border:
'1px solid rgba(255,255,255,.15)',


backdropFilter:'blur(10px)',


boxShadow:
'0 10px 25px rgba(0,0,0,.15)',


gap:'12px',


boxSizing:'border-box'


},






iconCircle:{


width:'48px',

height:'48px',


borderRadius:'50%',


background:
'linear-gradient(135deg,#00c6ff,#0072ff)',


display:'flex',

alignItems:'center',

justifyContent:'center',


color:'#fff',


fontSize:'24px',


boxShadow:
'0 0 20px rgba(0,140,255,.6)',


flexShrink:0


},






serviceText:{


margin:0,


fontSize:
'clamp(1rem,3.5vw,1.25rem)',


color:'#ffffff',


fontWeight:'600',


textAlign:'right',


lineHeight:'1.5'


}



};